import { Injectable } from '@angular/core';
import { FgiBackEndService } from '../../shared/fgi-back-end.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ModalidadeOperacionalRepasseDTO } from 'src/app/model/modalidade-operacional-repasse-dto.model';

@Injectable({
  providedIn: 'root'
})
export class ProdutosPermitidosService extends FgiBackEndService<any> {

  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/modalidade-operacional-repasse-bndes';
  }

  public listarTodos(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/buscar-todos/produtos`).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public listarTodosFiltrados(params?: any): Observable<any> {
    const options: any = blockUi();
    options.params = params
    return this.http.get(`${this.BASE_URL}/permitidos-filtrados`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public excluirProdutoModalidadeOperacional(idProduto: number): Observable<void> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/excluir/${idProduto}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<void>;
  }


  public salvarProdutoModalidadeOperacional(modalidadeOperacionalRepasseDTO: ModalidadeOperacionalRepasseDTO) {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/salvar`, modalidadeOperacionalRepasseDTO, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public mudaStatusPermitidaProdutoModalidadeOperacional(idProduto: number): Observable<void> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/${idProduto}/status`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<void>;
  }

}
